import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'isSerializable',
})
export class IsSerializablePipe implements PipeTransform {
  transform(value: unknown): boolean {
    try {
      JSON.stringify(value);
      return true;
    } catch (_error: any) {
      return false;
    }
  }
}
